/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Audio_Description_Export_Status_Video_Encoding_Extended_ProgressInputs */

const en_audio_description_export_status_video_encoding_extended_progress = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_Extended_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Encoding extended AD video: ${i?.percent}%`)
};

const fr_audio_description_export_status_video_encoding_extended_progress = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_Extended_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Encodage de la vidéo AD étendue : ${i?.percent}%`)
};

const de_audio_description_export_status_video_encoding_extended_progress = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_Extended_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kodierung von erweitertem AD-Video: ${i?.percent}%`)
};

const it_audio_description_export_status_video_encoding_extended_progress = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_Extended_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Codifica video AD esteso: ${i?.percent}%`)
};

const ru_audio_description_export_status_video_encoding_extended_progress = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_Extended_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Кодирование расширенного рекламного видео: ${i?.percent}%`)
};

const es_audio_description_export_status_video_encoding_extended_progress = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_Extended_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Codificación de vídeo AD extendido: ${i?.percent}%`)
};

const zh_cn2_audio_description_export_status_video_encoding_extended_progress = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_Extended_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`编码扩展广告视频：${i?.percent}%`)
};

const ja_audio_description_export_status_video_encoding_extended_progress = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_Extended_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`拡張ADビデオのエンコード: ${i?.percent}%`)
};

const hi_audio_description_export_status_video_encoding_extended_progress = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_Extended_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`विस्तारित विज्ञापन वीडियो को एन्कोड करना: ${i?.percent}%`)
};

const pt_pt2_audio_description_export_status_video_encoding_extended_progress = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_Extended_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Codificação de vídeo AD estendido: ${i?.percent}%`)
};

/**
* | output |
* | --- |
* | "Encoding extended AD video: {percent}%" |
*
* @param {Audio_Description_Export_Status_Video_Encoding_Extended_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_video_encoding_extended_progress = /** @type {((inputs: Audio_Description_Export_Status_Video_Encoding_Extended_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Video_Encoding_Extended_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_status_video_encoding_extended_progress(inputs)
	if (locale === "de") return de_audio_description_export_status_video_encoding_extended_progress(inputs)
	if (locale === "it") return it_audio_description_export_status_video_encoding_extended_progress(inputs)
	if (locale === "ru") return ru_audio_description_export_status_video_encoding_extended_progress(inputs)
	if (locale === "es") return es_audio_description_export_status_video_encoding_extended_progress(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_status_video_encoding_extended_progress(inputs)
	if (locale === "ja") return ja_audio_description_export_status_video_encoding_extended_progress(inputs)
	if (locale === "hi") return hi_audio_description_export_status_video_encoding_extended_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_status_video_encoding_extended_progress(inputs)
	return en_audio_description_export_status_video_encoding_extended_progress(inputs)
});